/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./preview-language-selector.vue?vue&type=template&id=7bc5c1bc&"
import script from "./preview-language-selector.vue?vue&type=script&lang=js&"
export * from "./preview-language-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports